/**
 * Filter names holds the name of a filter.
 * The name key is what is shown in the url
 * The order of the filters, will be the order in the menu
 *
 */

export const FILTER_NAMES = {
    priceRange: 'price',
    propertyTypes: 'propertyTypes',
    status: 'status',
    districts: 'districts',
    projectPhases: 'projectPhases',
    rooms: 'rooms',
    livingArea: 'livingArea',
    plotArea: 'plotArea',
    rental: 'rental',
    sunDirection: 'sunDirection',
    apartmentBuildings: 'apartmentBuildings',
};
